import type { IconSvgObject } from './types';

const KnifeBreadIcon: IconSvgObject = [
  ["path", { d: "M5.21543 20.2041L8.8737 15.7609C9.2196 15.3408 9.83793 15.2744 10.2651 15.6115L12.0039 16.9835L15 14L15.5 12H17.5V9.5H19.5L20 7L21.9961 6.50506C22 5.5 21.3939 4.81243 21.1416 4.45297C18.9917 2.10771 16.4067 3.07774 15.3459 4.03454L2.5194 17.9201C1.8084 18.6496 1.8453 19.6848 2.52025 20.4487C3.29121 21.3211 4.46073 21.0911 5.21543 20.2041Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default KnifeBreadIcon;
